import { InputWrapper as Wrapper } from '@vrplatform/components';
import type { ReactNode } from 'react';

export const InputWrapper = ({
  children,
  label,
  error,
}: {
  children: ReactNode;
  label: string;
  error?: string;
}) => (
  <Wrapper
    label={label}
    error={error}
    styles={{
      label: {
        fontWeight: 500,
      },
    }}
  >
    {children}
  </Wrapper>
);
